import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'
import ButtonCinestar from '../../../../components/Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../../components/Typography/Typography'

import { push } from '@lagunovsky/redux-react-router'
import { useDispatch } from 'react-redux'
import { getCookie } from 'services/token/helpers'
import './ClubMemberHeader.scss'
import hocClubMemberHeader from './hocClubmember'

const ClubMemberHeader = ({
    user,
    firstname,
    lastname,
    points,
    cardValidity,
    isExpiring,
    setCardProlonge,
    isCardValid,
}) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    const handleProlong = () => {
        setCardProlonge()
        dispatch(push('/order-summary'))
    }

    //key is used for rerendering if image is updated (the link is same, key is used)
    let key = 0
    if (!!user.imageId) {
        key = user.imageId
    }

    const expirationTextId = isCardValid ? 'userProfile.cardValidity' : 'userProfile.cardValidityExpired'

    let userImage = `images/cinestar/astronaut-avatar.png`
    const imgFromCookie = getCookie('profilePicture')
    if (imgFromCookie) {
        userImage = imgFromCookie
    }
    if (user.profile_picture) {
        userImage = user.profile_picture
    }

    return (
        <Container fluid className={'club-member-header d-flex align-items-center'}>
            <div className={'club-member-header--user d-flex align-items-center'}>
                <div className={'club-member-header--img'}>
                    <img key={key} src={userImage} alt={'avatar'} />
                </div>
                <div className={'d-flex flex-column gap-2'}>
                    <Typography variant={'sectionHeadline'}>
                        {firstname} {lastname}
                    </Typography>
                    <Typography variant={'p'} color={'magentaSecondary'}>
                        {intl.formatMessage({ id: 'global.currency.points' }, { points })}
                    </Typography>
                </div>
            </div>
            <div className={'club-member-header--validity d-flex align-items-center'}>
                <div className={'d-flex flex-column gap-2'}>
                    <Typography variant={'label'}>{intl.formatMessage({ id: expirationTextId })}</Typography>
                    <Typography variant={'label'}>{cardValidity}</Typography>
                </div>
                {isExpiring && (
                    <ButtonCinestar onClick={() => handleProlong()} variant={'primary-v1'} className={'text-uppercase'}>
                        {intl.formatMessage(
                            { id: 'buttons.extendMembership' },
                            { span: (chunks) => <span>{chunks}</span> }
                        )}
                    </ButtonCinestar>
                )}
            </div>
        </Container>
    )
}

export default hocClubMemberHeader(ClubMemberHeader)
